export var CallingCode;
(function (CallingCode) {
    function is(value) {
        return (typeof value == "string" &&
            value.length <= 5 &&
            (value == "+93" ||
                value == "+358" ||
                value == "+355" ||
                value == "+213" ||
                value == "+1684" ||
                value == "+376" ||
                value == "+244" ||
                value == "+1264" ||
                value == "+672" ||
                value == "+1268" ||
                value == "+54" ||
                value == "+374" ||
                value == "+297" ||
                value == "+61" ||
                value == "+43" ||
                value == "+994" ||
                value == "+1242" ||
                value == "+973" ||
                value == "+880" ||
                value == "+1246" ||
                value == "+375" ||
                value == "+32" ||
                value == "+501" ||
                value == "+229" ||
                value == "+1441" ||
                value == "+975" ||
                value == "+591" ||
                value == "+387" ||
                value == "+267" ||
                value == "+55" ||
                value == "+246" ||
                value == "+673" ||
                value == "+359" ||
                value == "+226" ||
                value == "+257" ||
                value == "+855" ||
                value == "+237" ||
                value == "+1" ||
                value == "+238" ||
                value == "+345" ||
                value == "+236" ||
                value == "+235" ||
                value == "+56" ||
                value == "+86" ||
                value == "+61" ||
                value == "+61" ||
                value == "+57" ||
                value == "+269" ||
                value == "+242" ||
                value == "+243" ||
                value == "+682" ||
                value == "+506" ||
                value == "+225" ||
                value == "+385" ||
                value == "+53" ||
                value == "+357" ||
                value == "+420" ||
                value == "+45" ||
                value == "+253" ||
                value == "+1767" ||
                value == "+1849" ||
                value == "+593" ||
                value == "+20" ||
                value == "+503" ||
                value == "+240" ||
                value == "+291" ||
                value == "+372" ||
                value == "+251" ||
                value == "+500" ||
                value == "+298" ||
                value == "+679" ||
                value == "+358" ||
                value == "+33" ||
                value == "+594" ||
                value == "+689" ||
                value == "+241" ||
                value == "+220" ||
                value == "+995" ||
                value == "+49" ||
                value == "+233" ||
                value == "+350" ||
                value == "+30" ||
                value == "+299" ||
                value == "+1473" ||
                value == "+590" ||
                value == "+1671" ||
                value == "+502" ||
                value == "+44" ||
                value == "+224" ||
                value == "+245" ||
                value == "+592" ||
                value == "+509" ||
                value == "+379" ||
                value == "+504" ||
                value == "+852" ||
                value == "+36" ||
                value == "+354" ||
                value == "+91" ||
                value == "+62" ||
                value == "+98" ||
                value == "+964" ||
                value == "+353" ||
                value == "+44" ||
                value == "+972" ||
                value == "+39" ||
                value == "+1876" ||
                value == "+81" ||
                value == "+44" ||
                value == "+962" ||
                value == "+77" ||
                value == "+254" ||
                value == "+686" ||
                value == "+850" ||
                value == "+82" ||
                value == "+965" ||
                value == "+996" ||
                value == "+856" ||
                value == "+371" ||
                value == "+961" ||
                value == "+266" ||
                value == "+231" ||
                value == "+218" ||
                value == "+423" ||
                value == "+370" ||
                value == "+352" ||
                value == "+853" ||
                value == "+389" ||
                value == "+261" ||
                value == "+265" ||
                value == "+60" ||
                value == "+960" ||
                value == "+223" ||
                value == "+356" ||
                value == "+692" ||
                value == "+596" ||
                value == "+222" ||
                value == "+230" ||
                value == "+262" ||
                value == "+52" ||
                value == "+691" ||
                value == "+373" ||
                value == "+377" ||
                value == "+976" ||
                value == "+382" ||
                value == "+1664" ||
                value == "+212" ||
                value == "+258" ||
                value == "+95" ||
                value == "+264" ||
                value == "+674" ||
                value == "+977" ||
                value == "+31" ||
                value == "+599" ||
                value == "+687" ||
                value == "+64" ||
                value == "+505" ||
                value == "+227" ||
                value == "+234" ||
                value == "+683" ||
                value == "+672" ||
                value == "+1670" ||
                value == "+47" ||
                value == "+968" ||
                value == "+92" ||
                value == "+680" ||
                value == "+970" ||
                value == "+507" ||
                value == "+675" ||
                value == "+595" ||
                value == "+51" ||
                value == "+63" ||
                value == "+872" ||
                value == "+48" ||
                value == "+351" ||
                value == "+1939" ||
                value == "+974" ||
                value == "+40" ||
                value == "+7" ||
                value == "+250" ||
                value == "+262" ||
                value == "+590" ||
                value == "+290" ||
                value == "+1869" ||
                value == "+1758" ||
                value == "+590" ||
                value == "+508" ||
                value == "+1784" ||
                value == "+685" ||
                value == "+378" ||
                value == "+239" ||
                value == "+966" ||
                value == "+221" ||
                value == "+381" ||
                value == "+248" ||
                value == "+232" ||
                value == "+65" ||
                value == "+421" ||
                value == "+386" ||
                value == "+677" ||
                value == "+252" ||
                value == "+27" ||
                value == "+211" ||
                value == "+500" ||
                value == "+34" ||
                value == "+94" ||
                value == "+249" ||
                value == "+597" ||
                value == "+47" ||
                value == "+268" ||
                value == "+46" ||
                value == "+41" ||
                value == "+963" ||
                value == "+886" ||
                value == "+992" ||
                value == "+255" ||
                value == "+66" ||
                value == "+670" ||
                value == "+228" ||
                value == "+690" ||
                value == "+676" ||
                value == "+1868" ||
                value == "+216" ||
                value == "+90" ||
                value == "+993" ||
                value == "+1649" ||
                value == "+688" ||
                value == "+256" ||
                value == "+380" ||
                value == "+971" ||
                value == "+44" ||
                value == "+1" ||
                value == "+598" ||
                value == "+998" ||
                value == "+678" ||
                value == "+58" ||
                value == "+84" ||
                value == "+1284" ||
                value == "+1340" ||
                value == "+681" ||
                value == "+967" ||
                value == "+260" ||
                value == "+263"));
    }
    CallingCode.is = is;
    function from(country) {
        return alpha2toCallingCode[country];
    }
    CallingCode.from = from;
    function to(callingCode) {
        return callingCodetoAlpha2[callingCode];
    }
    CallingCode.to = to;
    function seperate(phoneNumber) {
        let result = [undefined, phoneNumber];
        if (phoneNumber.substring(0, 1) == "+") {
            for (let end = 5; end > 1; end--) {
                const callingCode = phoneNumber.substring(0, end);
                if (CallingCode.is(callingCode)) {
                    result = [callingCode, phoneNumber.substring(end)];
                    break;
                }
            }
        }
        return result;
    }
    CallingCode.seperate = seperate;
})(CallingCode || (CallingCode = {}));
const callingCodetoAlpha2 = {
    "+93": "AF",
    "+358": ["FI", "AX"],
    "+355": "AL",
    "+213": "DZ",
    "+1684": "AS",
    "+376": "AD",
    "+244": "AO",
    "+1264": "AI",
    "+672": ["NF", "AQ"],
    "+1268": "AG",
    "+54": "AR",
    "+374": "AM",
    "+297": "AW",
    "+61": ["AU", "CX", "CC"],
    "+43": "AT",
    "+994": "AZ",
    "+1242": "BS",
    "+973": "BH",
    "+880": "BD",
    "+1246": "BB",
    "+375": "BY",
    "+32": "BE",
    "+501": "BZ",
    "+229": "BJ",
    "+1441": "BM",
    "+975": "BT",
    "+591": "BO",
    "+599": "BQ",
    "+387": "BA",
    "+267": "BW",
    "+55": "BR",
    "+246": "IO",
    "+673": "BN",
    "+359": "BG",
    "+226": "BF",
    "+257": "BI",
    "+855": "KH",
    "+237": "CM",
    "+1": ["US", "CA"],
    "+238": "CV",
    "+345": "KY",
    "+236": "CF",
    "+235": "TD",
    "+56": "CL",
    "+86": "CN",
    "+57": "CO",
    "+269": "KM",
    "+242": "CG",
    "+243": "CD",
    "+682": "CK",
    "+506": "CR",
    "+225": "CI",
    "+385": "HR",
    "+53": "CU",
    "+357": "CY",
    "+420": "CZ",
    "+45": "DK",
    "+253": "DJ",
    "+1767": "DM",
    "+1849": "DO",
    "+593": "EC",
    "+20": "EG",
    "+503": "SV",
    "+240": "GQ",
    "+291": "ER",
    "+372": "EE",
    "+251": "ET",
    "+500": ["FK", "GS"],
    "+298": "FO",
    "+679": "FJ",
    "+33": "FR",
    "+594": "GF",
    "+689": "PF",
    "+241": "GA",
    "+220": "GM",
    "+995": "GE",
    "+49": "DE",
    "+233": "GH",
    "+350": "GI",
    "+30": "GR",
    "+299": "GL",
    "+1473": "GD",
    "+590": ["GP", "BL", "MF"],
    "+1671": "GU",
    "+502": "GT",
    "+44": ["GB", "JE", "IM", "GG"],
    "+224": "GN",
    "+245": "GW",
    "+592": "GY",
    "+595": "PY",
    "+509": "HT",
    "+379": "VA",
    "+504": "HN",
    "+852": "HK",
    "+36": "HU",
    "+354": "IS",
    "+91": "IN",
    "+62": "ID",
    "+98": "IR",
    "+964": "IQ",
    "+353": "IE",
    "+972": "IL",
    "+39": "IT",
    "+1876": "JM",
    "+81": "JP",
    "+962": "JO",
    "+77": "KZ",
    "+254": "KE",
    "+686": "KI",
    "+850": "KP",
    "+82": "KR",
    "+965": "KW",
    "+996": "KG",
    "+856": "LA",
    "+371": "LV",
    "+961": "LB",
    "+266": "LS",
    "+231": "LR",
    "+218": "LY",
    "+423": "LI",
    "+370": "LT",
    "+352": "LU",
    "+853": "MO",
    "+389": "MK",
    "+261": "MG",
    "+265": "MW",
    "+60": "MY",
    "+960": "MV",
    "+223": "ML",
    "+356": "MT",
    "+692": "MH",
    "+596": "MQ",
    "+222": "MR",
    "+230": "MU",
    "+262": ["RE", "YT"],
    "+52": "MX",
    "+691": "FM",
    "+373": "MD",
    "+377": "MC",
    "+976": "MN",
    "+382": "ME",
    "+1664": "MS",
    "+212": "MA",
    "+258": "MZ",
    "+95": "MM",
    "+264": "NA",
    "+674": "NR",
    "+977": "NP",
    "+31": "NL",
    "+687": "NC",
    "+64": "NZ",
    "+505": "NI",
    "+227": "NE",
    "+234": "NG",
    "+683": "NU",
    "+1670": "MP",
    "+47": ["NO", "SJ"],
    "+968": "OM",
    "+92": "PK",
    "+680": "PW",
    "+970": "PS",
    "+507": "PA",
    "+675": "PG",
    "+51": "PE",
    "+63": "PH",
    "+872": "PN",
    "+48": "PL",
    "+351": "PT",
    "+1939": "PR",
    "+974": "QA",
    "+40": "RO",
    "+7": "RU",
    "+250": "RW",
    "+290": "SH",
    "+1869": "KN",
    "+1758": "LC",
    "+508": "PM",
    "+1784": "VC",
    "+685": "WS",
    "+378": "SM",
    "+239": "ST",
    "+966": "SA",
    "+221": "SN",
    "+381": "RS",
    "+248": "SC",
    "+232": "SL",
    "+65": "SG",
    "+421": "SK",
    "+386": "SI",
    "+677": "SB",
    "+252": "SO",
    "+27": "ZA",
    "+211": "SS",
    "+34": "ES",
    "+94": "LK",
    "+249": "SD",
    "+597": "SR",
    "+268": "SZ",
    "+46": "SE",
    "+41": "CH",
    "+963": "SY",
    "+886": "TW",
    "+992": "TJ",
    "+255": "TZ",
    "+66": "TH",
    "+670": "TL",
    "+228": "TG",
    "+690": "TK",
    "+676": "TO",
    "+1868": "TT",
    "+216": "TN",
    "+90": "TR",
    "+993": "TM",
    "+1649": "TC",
    "+688": "TV",
    "+256": "UG",
    "+380": "UA",
    "+971": "AE",
    "+598": "UY",
    "+998": "UZ",
    "+678": "VU",
    "+58": "VE",
    "+84": "VN",
    "+1284": "VG",
    "+1340": "VI",
    "+681": "WF",
    "+967": "YE",
    "+260": "ZM",
    "+263": "ZW",
};
const alpha2toCallingCode = {
    AF: "+93",
    AX: "+358",
    AL: "+355",
    DZ: "+213",
    AS: "+1684",
    AD: "+376",
    AO: "+244",
    AI: "+1264",
    AQ: "+672",
    AG: "+1268",
    AR: "+54",
    AM: "+374",
    AW: "+297",
    AU: "+61",
    AT: "+43",
    AZ: "+994",
    BS: "+1242",
    BH: "+973",
    BD: "+880",
    BB: "+1246",
    BY: "+375",
    BE: "+32",
    BZ: "+501",
    BJ: "+229",
    BM: "+1441",
    BT: "+975",
    BO: "+591",
    BQ: "+599",
    BA: "+387",
    BW: "+267",
    BR: "+55",
    IO: "+246",
    BN: "+673",
    BG: "+359",
    BF: "+226",
    BI: "+257",
    KH: "+855",
    CM: "+237",
    CA: "+1",
    CV: "+238",
    KY: "+345",
    CF: "+236",
    TD: "+235",
    CL: "+56",
    CN: "+86",
    CX: "+61",
    CC: "+61",
    CO: "+57",
    KM: "+269",
    CG: "+242",
    CD: "+243",
    CK: "+682",
    CR: "+506",
    CI: "+225",
    HR: "+385",
    CU: "+53",
    CY: "+357",
    CZ: "+420",
    DK: "+45",
    DJ: "+253",
    DM: "+1767",
    DO: "+1849",
    EC: "+593",
    EG: "+20",
    SV: "+503",
    GQ: "+240",
    ER: "+291",
    EE: "+372",
    ET: "+251",
    FK: "+500",
    FO: "+298",
    FJ: "+679",
    FI: "+358",
    FR: "+33",
    GF: "+594",
    PF: "+689",
    GA: "+241",
    GM: "+220",
    GE: "+995",
    DE: "+49",
    GH: "+233",
    GI: "+350",
    GR: "+30",
    GL: "+299",
    GD: "+1473",
    GP: "+590",
    GU: "+1671",
    GT: "+502",
    GG: "+44",
    GN: "+224",
    GW: "+245",
    GY: "+592",
    HT: "+509",
    VA: "+379",
    HN: "+504",
    HK: "+852",
    HU: "+36",
    IS: "+354",
    IN: "+91",
    ID: "+62",
    IR: "+98",
    IQ: "+964",
    IE: "+353",
    IM: "+44",
    IL: "+972",
    IT: "+39",
    JM: "+1876",
    JP: "+81",
    JE: "+44",
    JO: "+962",
    KZ: "+77",
    KE: "+254",
    KI: "+686",
    KP: "+850",
    KR: "+82",
    KW: "+965",
    KG: "+996",
    LA: "+856",
    LV: "+371",
    LB: "+961",
    LS: "+266",
    LR: "+231",
    LY: "+218",
    LI: "+423",
    LT: "+370",
    LU: "+352",
    MO: "+853",
    MK: "+389",
    MG: "+261",
    MW: "+265",
    MY: "+60",
    MV: "+960",
    ML: "+223",
    MT: "+356",
    MH: "+692",
    MQ: "+596",
    MR: "+222",
    MU: "+230",
    YT: "+262",
    MX: "+52",
    FM: "+691",
    MD: "+373",
    MC: "+377",
    MN: "+976",
    ME: "+382",
    MS: "+1664",
    MA: "+212",
    MZ: "+258",
    MM: "+95",
    NA: "+264",
    NR: "+674",
    NP: "+977",
    NL: "+31",
    NC: "+687",
    NZ: "+64",
    NI: "+505",
    NE: "+227",
    NG: "+234",
    NU: "+683",
    NF: "+672",
    MP: "+1670",
    NO: "+47",
    OM: "+968",
    PK: "+92",
    PW: "+680",
    PS: "+970",
    PA: "+507",
    PG: "+675",
    PY: "+595",
    PE: "+51",
    PH: "+63",
    PN: "+872",
    PL: "+48",
    PT: "+351",
    PR: "+1939",
    QA: "+974",
    RO: "+40",
    RU: "+7",
    RW: "+250",
    RE: "+262",
    BL: "+590",
    SH: "+290",
    KN: "+1869",
    LC: "+1758",
    MF: "+590",
    PM: "+508",
    VC: "+1784",
    WS: "+685",
    SM: "+378",
    ST: "+239",
    SA: "+966",
    SN: "+221",
    RS: "+381",
    SC: "+248",
    SL: "+232",
    SG: "+65",
    SK: "+421",
    SI: "+386",
    SB: "+677",
    SO: "+252",
    ZA: "+27",
    SS: "+211",
    GS: "+500",
    ES: "+34",
    LK: "+94",
    SD: "+249",
    SR: "+597",
    SJ: "+47",
    SZ: "+268",
    SE: "+46",
    CH: "+41",
    SY: "+963",
    TW: "+886",
    TJ: "+992",
    TZ: "+255",
    TH: "+66",
    TL: "+670",
    TG: "+228",
    TK: "+690",
    TO: "+676",
    TT: "+1868",
    TN: "+216",
    TR: "+90",
    TM: "+993",
    TC: "+1649",
    TV: "+688",
    UG: "+256",
    UA: "+380",
    AE: "+971",
    GB: "+44",
    US: "+1",
    UY: "+598",
    UZ: "+998",
    VU: "+678",
    VE: "+58",
    VN: "+84",
    VG: "+1284",
    VI: "+1340",
    WF: "+681",
    YE: "+967",
    ZM: "+260",
    ZW: "+263",
};
//# sourceMappingURL=CallingCode.js.map